import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/homepage/Footer";
import { ContentSidebar } from "@/components/marketing/ContentSidebar";

export const Route = createFileRoute('/comparisons')({
  component: ComparisonsLayout,
});

const comparisonsSidebar = {
  title: "Comparisons",
  sections: [
    {
      items: [
        { label: "Overview", href: "/comparisons" },
      ]
    },
    {
      title: "API Gateways",
      items: [
        { label: "vs Kong", href: "/comparisons/kong", iconName: "Router" },
        { label: "vs Apigee", href: "/comparisons/apigee", iconName: "Globe" },
        { label: "vs AWS API Gateway", href: "/comparisons/aws-api-gateway", iconName: "Cloud" },
      ]
    },
    {
      title: "AI Platforms",
      items: [
        { label: "vs Langfuse", href: "/comparisons/langfuse", iconName: "Activity" },
        { label: "vs LangChain", href: "/comparisons/langchain", iconName: "Bot" },
      ]
    }
  ]
};

function ComparisonsLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container px-6 py-12">
        <div className="flex gap-12">
          <ContentSidebar
            title={comparisonsSidebar.title}
            sections={comparisonsSidebar.sections}
          />
          <main className="flex-1 min-w-0">
            <Outlet />
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
